/**
 * Time period (AM/PM) constants
 */
export const TIME_PERIOD_AM = 'AM' as const;
export const TIME_PERIOD_PM = 'PM' as const;

/**
 * Default time values for new recording blocks
 */
export const DEFAULT_RECORDING_START_TIME = '07:00';
export const DEFAULT_RECORDING_END_TIME = '17:00';
export const ALL_DAY_START_TIME = '00:00';
export const ALL_DAY_END_TIME = '23:59';

/** Device-state/API field name for the recording schedule config */
export const RECORDING_SCHEDULE_CONFIG_KEY = 'recordingScheduleConfig';
